import React from 'react';
import { useSelector } from 'react-redux';
import './canvas_section.scss';
import Canvas from './canvas/Canvas';
import Zoom from './Zoom';
import ShapesButtons from './ShapesButtons';
import EditorNotifications from './EditorNotifications';
import { getError } from '../../../../redux/reticles/reticles-selectors';
// import { connect } from 'react-redux';

export default function Canvas_section(props) {

    const error = useSelector(getError);
    
    // constructor(props) {
    //     super(props)
    //     this.state = {
            // errorMessage: false,
    //     }
    // }

    // componentDidUpdate(prevProps) {
    //     if (prevProps.error !== this.props.error && this.props.error){
    //         this.setState({ errorMessage: true });
    //         setTimeout(() => {
    //             this.setState({ errorMessage: false});
    //         }, 10000);
    //     }
    // }

    // render () {
        return (
            <section className='canvas-section'>
                <Canvas
                    alignTop={props.alignTop}
                    instruments={props.instruments}
                    svgUpdateData={props.svgUpdateData}
                    getSelectedShapes={props.getSelectedShapes}
                    setGroupedShapes={props.setGroupedShapes}
                    strokeWidth={props.strokeWidth}
                    strokeColor={props.strokeColor}
                    align={props.align}
                    getCanvasShapesData={props.getCanvasShapesData}
                    getMarkersData={props.getMarkersData}
                    getNewMarkerCoords={props.getNewMarkerCoords}
                    getCurrentID={props.getCurrentID}
                    getDeletedIndex={props.getDeletedIndex}
                    getGroupedData={props.getGroupedData}
                    getSelectedShape={props.getSelectedShape}
                    getSelectedShapeWidth={props.getSelectedShapeWidth}
                    onSelectChangeMove={props.onSelectChangeMove}
                    focusedInput={props.focusedInput}
                    duplicateDeactivate={props.duplicateDeactivate}
                    undoRedoDeactivate={props.undoRedoDeactivate}
                    clearDeactivate={props.clearDeactivate}
                    activeShapeButton={props.activeShapeButton}
                    getSelectedShapeStrokeColor={props.getSelectedShapeStrokeColor}
                    getClearedData2Export={props.getClearedData2Export}
                    isExport={props.isExport}
                    getLineGridLength={props.getLineGridLength}
                    fillShapePrevOpacity={props.fillShapePrevOpacity}
                    fillShapePrevColor={props.fillShapePrevColor}
                    fillColor={props.fillColor}
                    opacity={props.opacity}
                    reticlesID={props.reticlesID}
                    activeTabId={props.activeTabId}
                    activeTab={props.activeTab}
                    gridDisabled={props.gridDisabled}
                    setCleanedSvg={props.setCleanedSvg}
                    disableEditParam={props.disableEditParam}
                    disableAxisSwitch={props.disableAxisSwitch}
                    firstSave={props.firstSave}
                    disableFirstSave={props.disableFirstSave}
                    disablefpSwitcher={props.disablefpSwitcher}
                    fpSwitchOff={props.fpSwitchOff}
                    switchOffisFillColorSet={props.switchOffisFillColorSet}
                    switchOffisStrokeColorSet={props.switchOffisStrokeColorSet}
                    layerMoveSwitcher={props.layerMoveSwitcher}
                    rotateSwitcher={props.rotateSwitcher}
                    getSelectedShapesType={props.getSelectedShapesType}
                    // strokeColor={this.props.strokeColor}
                    // strokeWidth={this.props.strokeWidth}
                    isShapeDelete={props.isShapeDelete}
                    toggleDeleteShape={props.toggleDeleteShape}
                    setStrokeType={props.setStrokeType}
                    strokeDasharray={props.strokeDasharray}
                    isStrokeTypeChanged={props.isStrokeTypeChanged}
                    resetStrokeTypeChanged={props.resetStrokeTypeChanged}
                    importReticle={props.importReticle}
                    clearImportData={props.clearImportData}
                    appVersion={props.appVersion}
                    setActiveShapeButton={props.setActiveShapeButton}
                />
                {props.error ? (
                    <EditorNotifications activeLink={props.activeLink}/>
                ) : null}
                <ShapesButtons activeLink={props.activeLink} setActiveShapeButton={props.setActiveShapeButton} selectedShapeProps={props.align.selectedShape} />
                <Zoom activeLink={props.activeLink} activeTabId={props.activeTabId}/>
            </section>
        )
    }
// }

// export default Canvas_section;
// const mapStateToProps = state => ({
//     error: getError(state),
// });

// export default connect(mapStateToProps)(Canvas_section);
